<script lang="ts" setup>
  import { storeToRefs } from 'pinia';

  import { ExternalUrlsEnum } from '@/assets/external-urls.enum';
  import { useI18 } from '@/plugins';
  import { authEnumRoutes } from '@/routes/auth/auth.enum.routes';
  import { profileEnumRoutes } from '@/routes/profile/profile.enum.routes';
  import { useAuthStore } from '@/stores/auth/auth.pinia';
  const { t } = useI18();
  const { user } = storeToRefs(useAuthStore());
  const { noRedirect } = defineProps<{
    noRedirect?: boolean;
  }>();
</script>

<template>
  <v-container>
    <v-row>
      <v-col
        lg="10"
        cols="12"
        class="mx-auto"
      >
        <v-row class="mt-2 mt-sm-16">
          <v-col
            lg="6"
            sm="12"
            cols="12"
            class="mx-auto"
          >
            <div
              class="d-flex justify-center flex-column ga-3 text-center align-center text-center"
            >
              <h1 class="text-grey text-h1 font-weight-bold">
                {{ t('shared.404') }}
              </h1>
              <p class="text-primary text-h4 font-weight-medium text-wrap">
                {{ t('shared.notFoundTitle') }}
              </p>
              <p
                class="text-body-2 text-grey-darken-3 mb-6"
                v-html="t('shared.notFoundText')"
              />
              <template v-if="!noRedirect">
                <v-btn-primary
                  v-if="user"
                  :to="{ name: profileEnumRoutes.root.name }"
                >
                  {{ t('shared.profile') }}
                </v-btn-primary>
                <v-btn-primary
                  v-else
                  :to="{ name: authEnumRoutes.login.name }"
                >
                  {{ t('shared.loginPage') }}
                </v-btn-primary>
              </template>
            </div>
          </v-col>
          <v-col
            lg="6"
            sm="12"
            cols="12"
          >
            <v-img
              :src="ExternalUrlsEnum.SVGs.default.notFound"
              alt="not-found"
              width="100%"
              height="300px"
              class="mt-n5"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
